module.exports = __webpack_public_path__ + "img/angular.9c3b786d.svg";